import classNames from 'classnames';
import React from 'react';
import SVGIcon from '../../components/SVGIcon';
import archiveIcon from '../../icons/non-prefilled/16x16/archive.svg';
import postIcon from '../../icons/non-prefilled/16x16/post.svg';
import postPinnedIcon from '../../icons/non-prefilled/16x16/postPinned.svg';
import templatePinnedIcon from '../../icons/non-prefilled/16x16/templatePinned.svg';
import templateIcon from '../../icons/non-prefilled/16x16/template.svg';
import * as styles from './TopicTreeCardPostIcon.module.scss';

interface TopicTreeCardPostIconProps {
  pinned: boolean;
  archived: boolean;
  template: boolean;
  movedOut: boolean;
}

const TopicTreeCardPostIcon = ({
  pinned,
  archived,
  template,
  movedOut,
}: TopicTreeCardPostIconProps) => {
  let icon = postIcon;

  if (template) {
    if (pinned) {
      icon = templatePinnedIcon;
    } else {
      icon = templateIcon;
    }
  } else if (pinned) {
    icon = postPinnedIcon;
  } else if (archived) {
    icon = archiveIcon;
  }

  return (
    <span
      className={classNames(styles.icon, {
        [styles.movedOut]: movedOut,
        [styles.template]: template,
      })}
    >
      <SVGIcon size="small">{icon}</SVGIcon>
    </span>
  );
};

export default TopicTreeCardPostIcon;
